import config from '../config/apiConfig'; //

export const getRepartidoresActivos = async () => {
    try {
        //alert("repartidores activos")
        const token = localStorage.getItem("token");
        const response = await fetch(`${config.api_url}/api/repartidores/activos`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }
        });

        if (!response.ok) throw new Error('Error al obtener repartidores');
        
        const data = await response.json();
        console.log("repartidores activos", data)
        return data; // Se espera un array: [{id, nombre, chat_id}, ...]
    } catch (error) {
        console.error("Error servicio repartidores:", error);
        return [];
    }
};